module.exports = __webpack_public_path__ + "img/示例条形码.752a284e.png";